import { motion, AnimatePresence } from "framer-motion";
import { createContext, useContext, useState } from "react";
import { createPortal } from "react-dom";
import { TickIcon } from "../../assets/images/TickIcon";
import { XIcon } from "../../assets/images/XIcon";
import { Warning } from "@mui/icons-material";

const ToastContext = createContext();

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = "success") => {
    const id = Math.random().toString(36).substr(2, 9);
    setToasts((currentToasts) => [...currentToasts, { id, message, type }]);
    setTimeout(() => {
      setToasts((currentToasts) =>
        currentToasts.filter((toast) => toast.id !== id)
      );
    }, 5000);
  };

  const removeToast = (id) => {
    setToasts((currentToasts) =>
      currentToasts.filter((toast) => toast.id !== id)
    );
  };

  const getToastIcon = (type) => {
    if (type === "success")
      return (
        <TickIcon
          bgColor="white"
          tickColor="black"
          className="hidden sm:block w-12"
        />
      );
    if (type === "error")
      return (
        <XIcon className="hidden sm:block w-12 text-black bg-white rounded-full " />
      );
    if (type === "info" || type === "warning")
      return <Warning className="hidden sm:block w-12 text-white" />;
    return null;
  };

  return (
    <ToastContext.Provider value={{ showToast, removeToast }}>
      {children}
      {toasts.length > 0 &&
        createPortal(
          <div className="fixed top-0 right-0 left-0 z-[100] p-4">
            <AnimatePresence>
              {toasts.map((toast) => (
                <motion.div
                  key={toast.id}
                  initial={{ opacity: 0, x: 100 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 100 }}
                  className="flex items-center justify-between px-2 py-1 max-w-md mx-auto mb-4 text-white bg-neutralStrongBlack rounded-xl shadow-lg"
                >
                  <div className="flex items-center p-4 gap-2">
                    {getToastIcon(toast.type)}
                    <p className="text-base font-bold">{toast.message}</p>
                  </div>
                  <button onClick={() => removeToast(toast.id)} className="p-4">
                    <XIcon className="w-4 h-4 text-white" />
                  </button>
                </motion.div>
              ))}
            </AnimatePresence>
          </div>,
          document.body
        )}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
}
